import * as React from 'react';

export const MenuIcon = ({
  width = 24,
  height = width,
}: JSX.IntrinsicElements['svg']) => (
  <svg
    className="fill-current"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    focusable="false"
    width={width}
    height={height}
    aria-hidden
  >
    <path
      fillRule="evenodd"
      d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
    />
  </svg>
);
